import React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import { units } from '@ha/dsl';

const styles = (t: Theme) =>
  createStyles({
    li: {
      fontSize: units.rem(1.25),
      [t.breakpoints.down('sm')]: {
        fontSize: units.rem(1),
      },
    },
  });

const MarkdownUl: React.FC<WithStyles<typeof styles>> = ({
  children,
  classes,
}) => <li className={classes.li}>{children}</li>;

const MarkdownLi = withStyles(styles)(MarkdownUl);
export { MarkdownLi };
